import React, { useState, useEffect } from 'react';
import { updateOpinion } from '../../data/api';

export const OpinionContent = ({ opinion }) => {
    const userId = localStorage.getItem('userId');

    // Estado para manejar el like y dislike
    const [opinionVotes, setOpinionVotes] = useState({
        like: false,
        dislike: false,
        likeCount: opinion.likes.length,
        dislikeCount: opinion.dislikes.length
    });

    // Efecto para inicializar el estado de los botones like y dislike
    useEffect(() => {
        setOpinionVotes(prevVotes => ({
            ...prevVotes,
            like: opinion.likes.includes(userId),
            dislike: opinion.dislikes.includes(userId)
        }));
    }, [opinion, userId]);

    const handleLike = async () => {
        if (!opinionVotes.like) {
            setOpinionVotes(prevVotes => ({
                like: true,
                dislike: false,
                likeCount: prevVotes.likeCount + 1,
                dislikeCount: prevVotes.dislike ? prevVotes.dislikeCount - 1 : prevVotes.dislikeCount
            }));

            const updatedOpinion = await updateOpinion({
                ...opinion,
                likes: [...opinion.likes, userId] || [],
                dislikes: opinion.dislikes.filter(id => id !== userId) || []
            }, localStorage.getItem('userId'),'like');

            if (updatedOpinion.status === 'error') {
                // Manejo de errores
                console.error(updatedOpinion.error);
                // Revertir el estado en caso de error
                setOpinionVotes(prevVotes => ({
                    ...prevVotes,
                    like: false,
                    likeCount: prevVotes.likeCount - 1
                }));
            }
        }
    };

    const handleDislike = async () => {
        if (!opinionVotes.dislike) {
            setOpinionVotes(prevVotes => ({
                like: false,
                dislike: true,
                likeCount: prevVotes.like ? prevVotes.likeCount - 1 : prevVotes.likeCount,
                dislikeCount: prevVotes.dislikeCount + 1
            }));

            const updatedOpinion = await updateOpinion({
                ...opinion,
                likes: opinion.likes.filter(id => id !== userId) || [],
                dislikes: [...opinion.dislikes, userId] || []
            }, localStorage.getItem('userId'),'dislike');

            if (updatedOpinion.status === 'error') {
                // Manejo de errores
                console.error(updatedOpinion.error);
                // Revertir el estado en caso de error
                setOpinionVotes(prevVotes => ({
                    ...prevVotes,
                    dislike: false,
                    dislikeCount: prevVotes.dislikeCount - 1
                }));
            }
        }
    };

    const espToText = (text) => {
        switch (text) {
            case '7':
                return 'Ing. Eléctrica'
            case '9':
                return 'Ing. Electrónica'
            case '17':
                return 'Ing. Mecánica'
            case '24':
                return 'Ing. Industrial'
            case '27':
                return 'Ing. Química'
            case '31':
                return 'Ing. Cívil'
            case 'H':
                return 'Homogéneas'
            default:
                return 'NI'
        }
    }

    return (
        <div className="opinion-div">
            <p className='opinion-title'>{espToText(opinion.career)} - {opinion.subject} - {opinion.course}</p>
            <p className='opinion-content'>{opinion.content}</p>
            <div className='opinion-votes'>
                <img 
                    className={`vote-img ${opinionVotes.like ? 'like-active' : 'like'}`} 
                    src={require(`../../assets/like${opinionVotes.like ? '_green' : ''}.png`)} 
                    alt="Like"
                    onClick={handleLike}
                />
                <p>{opinionVotes.likeCount}</p>
                <img 
                    className={`vote-img ${opinionVotes.dislike ? 'dislike-active' : 'dislike'}`} 
                    src={require(`../../assets/dislike${opinionVotes.dislike ? '_red' : ''}.png`)} 
                    alt="Dislike"
                    onClick={handleDislike}
                />
                <p>{opinionVotes.dislikeCount}</p>
            </div>
        </div>
    );
};
